import React from 'react';

/**
 * Ítem de resumen que muestra una etiqueta y su valor en una tarjeta compacta.
 * Usado en la vista de resultado de CAUForm.
 */
export function SummaryItem({ label, value }) {
  return (
    <div style={{ background: '#f9fdf9', borderRadius: '8px', padding: '10px 12px' }}>
      <p style={{ fontSize: '10px', color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.5px', margin: 0 }}>
        {label}
      </p>
      <p style={{ fontSize: '13px', fontWeight: 600, color: '#1a1a1a', margin: '3px 0 0', wordBreak: 'break-all' }}>
        {value || '-'}
      </p>
    </div>
  );
}

export default SummaryItem;
